var exports = {
  "button": "Button.module__button___X25lMl",
  "matchSkeletonHeight": "Button.module__matchSkeletonHeight___X25lMl",
  "small": "Button.module__small___X25lMl",
  "compact": "Button.module__compact___X25lMl",
  "superCompact": "Button.module__superCompact___X25lMl",
  "fitContent": "Button.module__fitContent___X25lMl",
  "fitContainer": "Button.module__fitContainer___X25lMl",
  "square": "Button.module__square___X25lMl",
  "primary": "Button.module__primary___X25lMl",
  "secondary": "Button.module__secondary___X25lMl",
  "danger": "Button.module__danger___X25lMl",
  "inverted": "Button.module__inverted___X25lMl",
  "invertedOutline": "Button.module__invertedOutline___X25lMl",
  "ghost": "Button.module__ghost___X25lMl",
  "recording": "Button.module__recording___X25lMl",
  "buttonRecordingPulse": "Button.module__buttonRecordingPulse___X25lMl",
  "spinner": "Button.module__spinner___X25lMl",
  "spinnerInner": "Button.module__spinnerInner___X25lMl",
  "spinnerItem": "Button.module__spinnerItem___X25lMl",
  "spinnerPulsingEllipsis": "Button.module__spinnerPulsingEllipsis___X25lMl",
  "iconWrapper": "Button.module__iconWrapper___X25lMl",
  "spinnerWrapper": "Button.module__spinnerWrapper___X25lMl",
  "hidden": "Button.module__hidden___X25lMl",
  "grid": "Button.module__grid___X25lMl",
};

__webpack_require__.r(module.exports = exports);
